'use strict';

import { Configuration, OpenAIApi } from "openai";
import { GoogleGenerativeAI }       from "@google/generative-ai";
import extract                      from 'extract-json-from-string';

const OPENAI_API_KEY = "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";
const GEMINI_API_KEY = "AIzaSyAAx47bCQBvbg-PkIaqbig9Gk-X0EwdGMI";

const configuration = new Configuration({ apiKey: OPENAI_API_KEY });
const openai = new OpenAIApi(configuration);

const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

const openaiWrapper = {

    chatWithGPT: async function(chat) {
        const messages = [
            { role: 'system', content: chat.system },
            { role: 'user', content: chat.user },
        ];

        const response = await openai.createChatCompletion({
            model: 'gpt-4',
            messages: messages,
        });
        return response.data.choices[0].message.content
    },

    chatCompletion: async function({ system, user, _messages, temperature, n }) {
        const messages = [
            { role: 'system', content: system },
            { role: 'user', content: user },
        ];

        if (_messages) {
            messages.push(..._messages);
        }

        try {
            const response = await openai.createChatCompletion({
                model: 'gpt-3.5-turbo',
                temperature,
                n,
                messages,
            });
            return response.data.choices;
        } catch (error) {
            console.error('Error chatCompletion:', error.response?.data || error.message);
            throw error;
        }
    },

    extractNodes: function({ choices }) {
        const _choices = []
        for (const choice of choices) {
            let node = ""
            try {
                node = JSON.parse(choice.message.content)
            } catch (e) {
                node = extract(choice.message.content)[0]
            }
            choice.nodes = node
            if (node) _choices.push(choice)
        }
        return _choices
    },

    geminiChatCompletion: async function({ system, user, _messages, temperature, candidateCount }) {
        try {
            const model = genAI.getGenerativeModel({
                model: "gemini-2.5-pro",
                systemInstruction: system,
                generationConfig: {
                    candidateCount: candidateCount || 1,
                    temperature: temperature || 1,
                },
            });

            const history = _messages ? _messages.map(msg => ({
                role: msg.role === 'assistant' ? 'model' : msg.role,
                parts: [{ text: msg.content }],
            })) : [];

            const chat = model.startChat({
                history: history,
            });

            const result = await chat.sendMessage(user);
            const response = result.response;

            return response.candidates;

        } catch (error) {
            console.error('Error en geminiChatCompletion:', error);
            throw error;
        }
    },

    extractNodesFromGemini: function({ candidates }) {
        const processedChoices = [];
        if (!candidates) {
            return processedChoices;
        }

        for (const candidate of candidates) {
            const rawText = candidate.content?.parts[0]?.text || "";
            let parsedNodes = null;

            const match = rawText.match(/```json\n([\s\S]*?)\n```/);
            const jsonString = match ? match[1] : rawText;

            try {
                parsedNodes = JSON.parse(jsonString);
            } catch (error) {
                console.error("Error al parsear el JSON extraído:", error);
                console.error("Texto que falló el parseo:", jsonString);
            }

            if (parsedNodes) {
                candidate.nodes = parsedNodes;
                processedChoices.push(candidate);
            }
        }

        return processedChoices;
    }
}

export default openaiWrapper;